

















































































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import swal from "sweetalert";
import Api from "@/api";
import { AxiosResponse } from "axios";

import FormErrorsMixin from "@/mixins/FormErrors";
import BaseMixin from "@/mixins/BaseMixin";
import ViewLoader from "@/components/Common/ViewLoader.vue";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import BackButton from "@/components/Common/Buttons/BackButton.vue";
import DangerButton from "@/components/Common/Buttons/DangerButton.vue";
import NavigationTabs from "@/components/Customers/Customer/NavigationTabs.vue";
import Error404 from "@/components/Common/Error404.vue";
import { ICustomer } from "@/interface";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    TextInput,
    InfoButton,
    BackButton,
    DangerButton,
    NavigationTabs,
    Error404
  }
})
export default class CustomerContactDetails extends Mixins(
  FormErrorsMixin,
  BaseMixin
) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "gender",
    "title",
    "first_name",
    "last_name",
    "email",
    "department",
    "phone_number.prefix",
    "phone_number.number"
  ];
  private noDataExist = false;
  private originalFirstName: string | null = null;
  private originalLastName: string | null = null;
  private selectedContactPerson: ICustomer = {
    gender: null,
    title: null,
    first_name: null,
    last_name: null,
    email: null,
    department: null, //position
    phone_number: {
      prefix: null,
      number: null
    }
  };
  private selectedCustomerId: string | null = null;
  private selectedContactPersonId: string | null = null;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedCustomerId = vm.$route.params.customer_id;
      vm.selectedContactPersonId = vm.$route.params.contact_person_id;
      if (
        typeof vm.selectedCustomerId !== "undefined" &&
        vm.selectedCustomerId !== null &&
        typeof vm.selectedContactPersonId !== "undefined" &&
        vm.selectedContactPersonId !== null
      ) {
        if (vm.$route.query.contact_person_created) {
          swal("Success!", "The contact person was created.", "success").then(
            () => {
              window.history.pushState(
                {},
                document.title,
                window.location.pathname
              );
            }
          );
        }
        vm.getContactPerson(() => {
          //
        });
      }
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (
      typeof this.selectedCustomerId !== "undefined" &&
      this.selectedCustomerId !== null &&
      typeof this.selectedContactPersonId !== "undefined" &&
      this.selectedContactPersonId !== null
    ) {
      this.getContactPerson(() => {
        //
      });
    }
    next();
  }

  private createOrUpdateContactPerson(): void {
    if (this.selectedContactPersonId == null) {
      this.createContactPerson();
    } else {
      this.updateContactPerson();
    }
  }

  private createContactPerson(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "customers/" + this.selectedCustomerId + "/contact-persons"
    );

    Api()
      .post(endpoint, this.selectedContactPerson)
      .then((response: AxiosResponse) => {
        this.selectedContactPersonId = response.data.data.id;
        this.$router.push({
          name: "CustomerContactDetails",
          params: {
            customer_id: `${this.selectedCustomerId}`,
            contact_person_id: `${this.selectedContactPersonId}`
          },
          query: { contact_person_created: "true" }
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#contact-person-last-name", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private getContactPerson(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "customers/" +
        this.selectedCustomerId +
        "/contact-persons/" +
        this.selectedContactPersonId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedContactPerson = response.data.data;
        if (this.selectedContactPerson.first_name !== undefined) {
          this.originalFirstName = this.selectedContactPerson.first_name;
        }
        if (this.selectedContactPerson.last_name !== undefined) {
          this.originalLastName = this.selectedContactPerson.last_name;
        }
        if (typeof successCallback == "function") {
          successCallback(response.data.data);
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateContactPerson(): void {
    if (this.loading || this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "customers/" +
        this.selectedCustomerId +
        "/contact-persons/" +
        this.selectedContactPersonId
    );

    Api()
      .put(endpoint, this.selectedContactPerson)
      .then(() => {
        this.getContactPerson(() => {
          //
        });
        swal({
          title: "Success!",
          text: "The contact person was updated.",
          icon: "success"
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#contact-person-last-name", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private deleteContactPerson(): void {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The contact person will be deleted",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint = this.$partnerEndpoint(
          "customers/" +
            this.selectedCustomerId +
            "/contact-persons/" +
            this.selectedContactPersonId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router.push({
              name: "CustomerContacts",
              query: { contact_person_deleted: "true" }
            });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete contact persons.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }
}
